import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ValidateService } from '../services/validate.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  first_name : String;
  last_name : String;
  email : String;
  contact_no :  String;
  word1 :String;
  word2 :String;
  word3 :String;
  word4 :String;
  heading  :String;
  constructor(
    private validateService:ValidateService,
    private flashMessage: FlashMessagesService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.languageSelector();
      this.authService.getProfile().subscribe(data =>{
        console.log(data);
        this.first_name = data.content.first_name;
        this.last_name = data.content.last_name;
        this.email = data.content.email;
        this.contact_no = data.content.contact_no;
      });
  }

  languageSelector(){
      let lang = localStorage.getItem('language');
      if(lang == "S"){
        this.word1 = "මුල් නම";
        this.word2 = "අවසන් නම";
        this.word3 = "විද්යුත් තැපැල් ලිපිනය";
        this.word4 = "ඇමතුම් අංකය";
        this.heading = "පරිශීලක පැතිකඩ";
      }else if(lang =="T"){
        this.word1 = "முதல் பெயர்";
        this.word2 = "கடைசி பெயர்";
        this.word3 = "மின்னஞ்சல் முகவரி";
        this.word4 = "தொடர்பு எண்";
        this.heading = "பயனர் விவரம்"
      }else{
        this.word1 = "First Name";
        this.word2 = "Last Name";
        this.word3 = "Email address";
        this.word4 = "Contact No";
        this.heading = "User Profile"
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user.component.ts